import React from 'react';
import * as classes from './CircleBG.module.scss';
import rightCircle from '../../../../../assets/images/right-circle.svg';
import leftCircle from '../../../../../assets/images/circle-left.svg';
import cn from 'classnames';

interface Props {
  left?: boolean;
}

const CircleBg = ({ left }: Props) => {
  return (
    <div className={classes.wrapper}>
      <div className={cn(classes.image, left && classes.left)}>
        <img src={left ? leftCircle : rightCircle} alt='' />
      </div>
    </div>
  );
};

export default CircleBg;
